// frontend/src/components/profile/AIUsageTimeline.tsx

import { AIUsageEntry } from '../../types/profile.types';

function formatDate(iso: string): string {
  const date = new Date(iso);
  const now = new Date();
  const diffDays = Math.floor((now.getTime() - date.getTime()) / 86400000);
  const time = date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });

  if (diffDays === 0) return `Bugün, ${time}`;
  if (diffDays === 1) return `Dün, ${time}`;
  return `${diffDays} gün önce, ${time}`;
}

interface AIUsageTimelineProps {
  entries: AIUsageEntry[];
}

export function AIUsageTimeline({ entries }: AIUsageTimelineProps) {
  return (
    <div className="card" style={{ marginTop: 24 }}>
      <h3 className="parent-section-title">AI Kullanım Geçmişi</h3>
      {entries.length === 0 ? (
        <p className="parent-empty-text">Henüz AI Mentor ile bir sohbetin yok.</p>
      ) : (
        <div className="profile-timeline">
          {entries.map((entry, i) => (
            <div className="profile-timeline-item" key={entry.id}>
              <div className={`profile-timeline-dot ${i === 0 ? 'active' : ''}`} />
              <div>
                <div className="profile-timeline-title">{entry.title}</div>
                <div className="profile-timeline-date">{formatDate(entry.occurredAt)}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
